export function LoadMore({
  hasMore,
  loading,
  total,
  count,
  onClick,
}: {
  hasMore: boolean;
  loading: boolean;
  total: number;
  count: number;
  onClick: () => void;
}) {
  if (!hasMore) {
    return (
      <p className="load-more-done" aria-live="polite">
        that's everything — {total} in all
      </p>
    );
  }
  const remaining = total - count;
  return (
    <div className="load-more">
      <button
        type="button"
        className="load-more-btn"
        onClick={onClick}
        disabled={loading}
      >
        {loading ? "pulling more…" : `load more (${remaining} more)`}
      </button>
    </div>
  );
}
